import { mapState, mapMutations } from 'vuex';

import { LOCATIONS_NAMESPACE, SET_SUFFIX } from '@store/modules/locations.types';

export default {
  name: 'LocationSelector',

  computed: {
    ...mapState(LOCATIONS_NAMESPACE, {
      suffix: ({ suffix }) => suffix,
      locations: ({ locations }) => locations
        .map(({ name: text, suffix: value }) => ({ text, value })),
    }),
    selectedLocation: {
      get() {
        return this.suffix;
      },
      set(newValue) {
        this.updateLocationSuffix(newValue);
      },
    },
  },

  watch: {
    '$route.query.suffix'(newValue) { //eslint-disable-line
      if (newValue !== this.suffix) {
        this.updateLocationSuffix(newValue || this.suffix);
      }
    },
  },

  methods: {
    ...mapMutations(LOCATIONS_NAMESPACE, {
      updateLocationSuffix(commit, suffix) {
        commit(SET_SUFFIX, suffix);

        const { meta = {} } = this.$route;
        let to;

        if (meta.parent) {
          to = { ...meta.parent.to };
          to.query.suffix = suffix;
          this.$router.push(to);
          return;
        }

        to = { ...(meta?.navigation?.to?.query || meta?.query || {}) };
        to.suffix = suffix;

        this.$router.push({ query: to }, null, () => {});
      },
    }),
  },
};
